<template>
  <div
    class="d-flex flex-column align-items-center justify-content-center"
    style="height: 75vh"
  >
    <!-- Login Form -->
    <form
      v-if="!requireCode"
      class="p-4 bg-light rounded shadow-sm"
      style="min-width: 350px; max-width: 100%"
      @submit.prevent="handleSubmit"
    >
      <div class="text-center mb-4" style="margin-top: -105px">
        <router-link to="/">
          <img src="/favicon.ico" class="rounded-circle" height="150" width="150" />
        </router-link>
      </div>
      <h2 class="text-center mb-4">Login</h2>

      <!-- Username field -->
      <div class="mb-3">
        <label for="username" class="form-label">Username</label>
        <input
          type="text"
          id="username"
          v-model="username"
          class="form-control"
          required
        />
      </div>

      <!-- Password field with toggle visibility -->
      <div class="mb-3 form-group">
        <label for="password" class="form-label">Password</label>
        <div class="input-group">
          <input
            :type="passwordFieldType"
            id="password"
            v-model="password"
            class="form-control"
            required
          />
          <span
            :class="
              passwordFieldType === 'password' ? 'bi bi-eye-slash-fill' : 'bi bi-eye-fill'
            "
            @click="togglePasswordVisibility"
            class="input-group-text"
            style="cursor: pointer"
          ></span>
        </div>
      </div>

      <div class="col-12 mb-2 px-0">
        <div v-if="errmsg" class="alert alert-danger mx-0">{{ errmsg }}</div>
      </div>

      <!-- Submit and Cancel buttons -->
      <button type="submit" class="btn btn-danger w-100 mb-2">Login</button>
      <button
        type="button"
        @click.prevent="handleCancelClick"
        class="btn btn-secondary w-100"
      >
        Cancel
      </button>
    </form>
  </div>
</template>
<script setup>
import { nextTick, ref } from "vue";
import store from "@/store";
import router from "@/router";
import spinnerService from "@/services/spinnerService";
import userService from "@/services/userService";
import { encryptData } from "@/utils/crypto";
import toastService from "@/services/toastService";
import signalRService from "@/services/signalRService";
const username = ref("");
const password = ref("");
const accesscode = ref("");
const requireCode = ref(false);
const passwordFieldType = ref("password"); // Track whether password is visible or hidden
const errmsg = ref("");
const returnURL = router.currentRoute.value.query.return_url || "/";
const isSubmitting = ref(false);
const togglePasswordVisibility = () => {
  passwordFieldType.value = passwordFieldType.value === "password" ? "text" : "password";
};

const handleSubmit = async () => {
  isSubmitting.value = true;
  errmsg.value = "Signing in...";
  try {
    spinnerService.show();
    const user = await store.dispatch("auth/login", {
      username: username.value,
      password: password.value,
    });
    if (!user.hasNextAction) {
      //router.replace(returnURL);
      window.location.href = returnURL;
      spinnerService.hide();
    } else {
      requireCode.value = true;
    }
  } catch (error) {
    console.error("Login error:", error);
    errmsg.value = error.error ? error.error.message : "Server is unreachable.";
    if (errmsg.value && errmsg.value.toLowerCase().includes("subscription")) {
      window.location.href = "/subscription-expired";
    } else {
      toastService.error(errmsg.value);
    }
    spinnerService.hide();
  } finally {
    isSubmitting.value = false;
  }
};
// eslint-disable-next-line no-unused-vars
const handleSubmitCode = async () => {
  isSubmitting.value = true;
  try {
    errmsg.value = "";
    const user = await store.dispatch("auth/submitAccessCode", {
      username: username.value,
      password: accesscode.value,
    });
    if (!user.hasNextAction) {
      router.replace(returnURL);
    } else {
      requireCode.value = true;
    }
  } catch (error) {
    console.error("Login error:", error);
    errmsg.value = error.error ? error.error.message : "Server is unreachable.";
    if (errmsg.value && errmsg.value.toLowerCase().includes("subscription")) {
      window.location.href = "/subscription-expired";
    } else {
      toastService.error(errmsg.value);
    }
  } finally {
    isSubmitting.value = false;
  }
};
// eslint-disable-next-line no-unused-vars
const handleModifiedSubmit = async () => {
  spinnerService.show();
  errmsg.value = "";
  isSubmitting.value = true;
  const response = await userService.submitLogin({
    username: username.value,
    password: password.value,
  });
  if (response.success) {
    if (!response.hasNextAction) {
      const user = response.user;
      localStorage.setItem("user", encryptData(JSON.stringify(user)));
      await store.dispatch("setUser", user);
      await nextTick();
      // Start token expiration timer
      //await signalRService.initializeConnection();
      store.dispatch("startTokenExpirationTimer", user.expiresIn);
      // requireCode.value = true;
      await signalRService.initializeConnection();
      setTimeout(() => {
        router.replace(returnURL);
      }, 200);
    } else {
      requireCode.value = true;
    }
  } else {
    alert("asd");
    if (errmsg.value && errmsg.value.toLowerCase().includes("subscription")) {
      window.location.href = "/subscription-expired";
    } else {
      errmsg.value = response.message;
      toastService.error(response.message);
    }
  }
  isSubmitting.value = false;
  spinnerService.hide();
};

const handleCancelClick = () => {
  router.replace("/");
};
</script>

<style scoped>
/* Ensure the form has a minimum and maximum width for responsiveness */
@media (max-width: 576px) {
  form {
    width: 100%;
    margin-left: 10px;
    margin-right: 10px;
  }
}
</style>
